/* eslint-disable no-underscore-dangle */
import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'api';
import { OKR_OBJECTIVE_BY_ID } from 'constants/api';
import { showOLDialog } from 'store/optimisticLocking';
import dayjs from 'dayjs';
import { generateURL } from 'helpers';
import { OkrObjectiveResponse } from '../interfaces';
import { storeName } from '../config';

export const deleteOkrObjective = createAsyncThunk<
  OkrObjectiveResponse,
  { periodId: string; id: string }
>(`${storeName}/deleteOkrObjective`, async ({ periodId, id }, thunkAPI) =>
  api.axios
    .delete<OkrObjectiveResponse>(
      generateURL(OKR_OBJECTIVE_BY_ID, { periodId, id }),
    )
    .then((res) => res.data)
    .catch((e) => {
      // optimistic locking error handling
      if (e.response?.status === 412) {
        thunkAPI.dispatch(
          showOLDialog({
            type: 'scorecard',
            params: {
              name: e.response?.data?.__meta?.lastActivity?.actor.fullName,
              date: dayjs(
                e.response?.data?.__meta?.lastActivity?.doneAt,
              ).format('HH:mm DD.MM.YYYY'),
            },
          }),
        );
      }

      return thunkAPI.rejectWithValue({
        ...e.response?.data,
        response: {
          status: e.response?.status,
        },
      });
    }),
);
